<template>
  <div>
    <el-form
      ref="lxpsForm"
      :rules="rules"
      label-width="120px"
      :hide-required-asterisk="false"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label">{{ baseInfo.courseName }}</el-col>
        </el-row>
        <div class="card_content">
          <div>
            <span>课题编号:</span>
            <span>{{ baseInfo.courseId }}</span>
          </div>
          <div>
            <span>课题负责人:</span>
            <span>{{ baseInfo.courseLeaderName }}</span>
          </div>
          <div>
            <span>课题主要成员:</span>
            <span>{{ baseInfo.memberName }}</span>
          </div>
        </div>
      </div>

      <div class="card">
        <el-row>
          <el-col :span="24" class="label"
            >课题研究进展情况（请根据立项申请表中的时间计划安排，说明任务完成情况）</el-col
          >
        </el-row>
        <div>
          <div class="btn">
            <el-button
              type="primary"
              icon="el-icon-upload"
              size="small"
              @click="handleToUpload()"
              >上传附件</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="handleToDownload()"
              >下载模板</el-button
            >
          </div>
        </div>
        <el-row>
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              style="
                margin-left: 30px;
                color: #fff;
                background-color: #1c84c6;
                border-color: #1c84c6;
              "
              @click="addDialog = true"
              >添加</el-button
            >
          </div>
          <div style="padding: 15px">
            <el-table
              :max-height="height"
              :data="zqjcList"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="操作"
                align="left"
                min-width="120px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    @click="handleEditOpen(scope.row)"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    type="danger"
                    @click="delSituationItem(scope.row)"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="时间计划"
                align="left"
                prop="planTime"
                min-width="120px"
                :show-overflow-tooltip="true"
              />

              <el-table-column
                label="任务内容"
                align="left"
                prop="taskContent"
                min-width="120px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="进展情况"
                align="left"
                prop="progress"
                min-width="150px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="备注"
                align="left"
                prop="remark"
                min-width="250px"
                :show-overflow-tooltip="true"
              />
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
            <pagination
              v-show="zqjcList.length > 0"
              :total="zqjcListCount"
              :page.sync="zqjcParams.page"
              :limit.sync="zqjcParams.pageSize"
              @pagination="getZqjcjdqk"
            />
          </div>
        </el-row>
      </div>
      <div
        class="card card3"
        v-if="baseInfo.metaPropList && baseInfo.metaPropList.length > 0"
      >
        <el-row>
          <el-col :span="24" class="label">研究方案</el-col>
        </el-row>
        <el-row>
          <el-col
            :span="24"
            v-for="(item, index) in baseInfo.metaPropList"
            :key="index"
            style="padding-left: 30px"
          >
            <div class="card3_label">
              <span v-if="item.required == '1'" class="red_label">*</span>
              <span>{{ item.cname }}</span>
            </div>
            <div
              :id="'wangEditor_zqjc_form' + index"
              v-if="item.type == '2'"
            ></div>
            <div class="content_text">
              <el-input
                v-model="item.propValue"
                type="textarea"
                :autosize="{ minRows: 6 }"
                show-word-limit
                v-if="item.type == '1'"
                @input="handeleChangeInput"
              ></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card card4" v-if="isFeedbackProcessing">
        <el-row>
          <el-col :span="24" class="label">意见反馈处理情况</el-col>
          <div class="card4_div">
            <el-col>
              <el-radio-group v-model="feedbackType">
                <el-radio label="1">意见反馈已处理完毕</el-radio>
                <el-radio label="2">暂时不处理</el-radio>
              </el-radio-group>
            </el-col>
            <el-col>
              <el-table
                :max-height="height"
                :data="feedbackList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  label="状态"
                  align="left"
                  prop="status"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />

                <el-table-column
                  label="反馈人"
                  align="left"
                  prop="ygbh"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="反馈时间"
                  align="left"
                  prop="feedbackTime"
                  min-width="150px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="意见反馈"
                  align="left"
                  prop="content"
                  min-width="250px"
                  :show-overflow-tooltip="true"
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      title="添加进展情况"
      :visible.sync="addDialog"
      width="700px"
      v-if="addDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <AddProgress
        ref="addProgress"
        @getParentForm="getData"
        :mxParams="mxParams"
      ></AddProgress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleAddProgress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑进展情况"
      :visible.sync="editDialog"
      width="700px"
      v-if="editDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <EditProgress
        ref="editProgress"
        :mxParams="mxParams"
        :editForm="editForm"
        @getParentForm="getData"
      ></EditProgress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleEditProgress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="课题结果查看"
      :visible.sync="handleResultDialog"
      width="90%"
      v-if="handleResultDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <CourseResult :mxParams="mxParams"></CourseResult>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleResultDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import AddProgress from "./addProgress.vue";
import EditProgress from "./editProgress.vue";
// import CourseResult from "../result.vue";
import {
  getMidCheckForm,
  getCourseSituation,
  delSituation,
  insertMidCheck,
} from "@/api/course.js";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Treeselect,
    AddProgress,
    EditProgress,
    Pagination,
    CourseResult: () => import("../result.vue"),
  },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: {
        metaPropList: [],
      },
      height: 500,
      rules: {},
      cyList: [
        {
          name: "",
        },
      ],
      editor: [],
      zqjcList: [],
      zqjcListCount: 0,
      zqjcParams: {
        page: 1,
        pageSize: 10,
      },
      editForm: {},
      feedbackList: [],
      feedbackType: null,
      isFeedbackProcessing: null,
      handleResultDialog: false,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo.metaPropList && this.baseInfo.metaPropList.length > 0) {
        let tempIndexArr = [];
        for (let i in this.baseInfo.metaPropList) {
          if (this.baseInfo.metaPropList[i].type == 2) {
            tempIndexArr.push(i);
          }
        }
        for (let i of tempIndexArr) {
          let editor = new wangEditor(`#wangEditor_zqjc_form${i}`);
          editor = this.editorConfig(editor);
          editor.txt.html(this.baseInfo.metaPropList[i].propValue);
          this.editor.push(editor);
        }
        clearInterval(timer);
      }
    }, 50);
  },

  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    getData() {
      this.addDialog = false;
      this.editDialog = false;
      const courseId = this.mxParams.id;
      getMidCheckForm({ courseId }).then((res) => {
        if (res.code == 0) {
          this.baseInfo = res.data.midCheckInfo;
          this.feedbackList = [res.data.feedback];
          this.feedbackType = res.data.midCheckInfo.feedbackType;
          this.isFeedbackProcessing = res.data.isFeedbackProcessing;
        }
      });
      this.getZqjcjdqk();
    },
    //中期检查进度情况
    getZqjcjdqk() {
      const { page, pageSize } = this.zqjcParams;
      getCourseSituation({ page, pageSize, courseId: this.mxParams.id }).then(
        (res) => {
          if (res.code == 0) {
            this.zqjcList = res.data;
            this.zqjcListCount = res.count;
          }
        }
      );
    },

    delSituationItem(row) {
      delSituation({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        }
      });
    },
    editCy(row) {
      this.editDialog = true;
      this.mxParams.id = row.id;
    },

    handleAddProgress() {
      this.$refs.addProgress.save();
    },
    handleEditProgress() {
      this.$refs.editProgress.save();
    },
    handleEditOpen(row) {
      this.editForm = row;
      this.editDialog = true;
    },
    saveForm() {
      this.baseInfo.feedbackType = this.feedbackType;
      let editorIndex = 0;
      for (let i in this.baseInfo.metaPropList) {
        const item = this.baseInfo.metaPropList[i];
        if (item.type == 2) {
          item.propValue = this.editor[editorIndex].txt.html();
          editorIndex = editorIndex + 1;
        }
        if (item.required == 1 && !item.propValue) {
          this.$message.error("请输入" + item.cname);
          return;
        }
      }

      insertMidCheck(this.baseInfo).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handeleChangeInput(e) {
      this.$forceUpdate();
    },
    handleToDownload() {
      this.$router.push({
        name: "courseFile",
        query: { ktsx: this.mxParams.group + "", wjlx: "2", ssjd: "4" },
      });
    },
    handleToUpload() {
      const row = { id: this.baseInfo.courseId, step: 17 };
      this.handleView(row);
    },
    handleView(row) {
      this.handleResultDialog = true;
      this.mxParams = { ...this.mxParams, ...row };
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.card3 {
  .card3_label {
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}
.card4 .card4_div {
  margin-top: 15px;
  padding: 0 30px;
}

.red_label {
  color: #ff0000;
  margin-right: 5px;
}
.btn {
  position: fixed;
  right: 120px;
  z-index: 100001;
}
</style>